import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { useToggle } from "@vueuse/core";

import UiIconBtn from "./ui/UiIconBtn.vue";

import AccountSelectModal from "./AccountSelectModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountSelect',
  setup(__props) {

const showModal = ref(false);
const toggleModal = useToggle(showModal);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UiIconBtn, _mergeProps(_ctx.$attrs, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleModal)())),
      icon: "Selector",
      variant: "tertiary"
    }), null, 16),
    _createVNode(AccountSelectModal, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})